import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from './services/user.service';
import { UserInformation } from './model/user-information.model';

/**
 * Blocks route activation for users that are not an administrator. The
 * back-end stays the source of truth, this only keeps admin-only screens out
 * of reach for the rest of the users.
 */
export const adminGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.getUserInformation().pipe(
    map((userInformation: UserInformation): boolean | UrlTree => {
      return userInformation.isAdmin ? true : router.createUrlTree(['/']);
    }),
    // When the user information cannot be loaded, assume the user is not an admin
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
